import { render, staticRenderFns } from "./TradeRequestDirectItemForm.vue?vue&type=template&id=742e6e29"
import script from "./TradeRequestDirectItemForm.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports